export default {
  scheme: 'Schéma',
  schemeName: 'Názov schémy zakladania',
  description: 'Popis',
  images: 'Obrázky',
};
